import { RFIconProps } from "../types";

export default function ArrowIcon(props: RFIconProps) {
	return (
		<svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M4.50011 3.70652L0.921822 0.156967C0.710865 -0.0523243 0.368851 -0.0523243 0.158226 0.156967C-0.0527423 0.36627 -0.0527423 0.705225 0.158226 0.914528L4.11848 4.84303C4.32944 5.05232 4.67145 5.05232 4.88208 4.84303L8.84196 0.914538C8.94744 0.809898 9 0.672743 9 0.535588C9 0.398444 8.94744 0.261289 8.84159 0.156978C8.63063 -0.052313 8.28897 -0.052313 8.07799 0.156978L4.50011 3.70652Z"
				fill="currentColor"
			/>
		</svg>
	);
}
